"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.THUMBNAIL_SIZE = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
var capture_thumbnail_style_1 = require("../capture.thumbnail/capture.thumbnail.style");
exports.CSS = {
    container: 'c-CaptureBar'
};
exports.THUMBNAIL_SIZE = 100;
exports.Style = (_a = {},
    _a[exports.CSS.container] = (_b = {
            padding: theme_1.DefaultTheme.space(2),
            display: 'flex',
            'flex-direction': 'column',
            width: exports.THUMBNAIL_SIZE + (theme_1.DefaultTheme.spacingFactor * 2),
            'align-items': 'center',
            'overflow-x': 'hidden',
            'overflow-y': 'auto',
            'border-left': "1px solid ".concat(theme_1.DefaultTheme.font.color.divider),
            'border-right': "1px solid ".concat(theme_1.DefaultTheme.font.color.divider)
        },
        _b["& .".concat(capture_thumbnail_style_1.CSS.container)] = {
            margin: "".concat(theme_1.DefaultTheme.space(1), " 0"),
            width: "".concat(exports.THUMBNAIL_SIZE, "px"),
            height: "".concat(exports.THUMBNAIL_SIZE, "px"),
            'min-width': "".concat(exports.THUMBNAIL_SIZE, "px"),
            'min-height': "".concat(exports.THUMBNAIL_SIZE, "px")
        },
        _b["& .".concat(capture_thumbnail_style_1.CSS.container, ":hover")] = {
            border: "".concat(theme_1.DefaultTheme.space(1), " solid ").concat(theme_1.DefaultTheme.color.accent)
        },
        _b),
    _a);
//# sourceMappingURL=capture.bar.style.js.map